module.exports = __webpack_public_path__ + "static/media/file-pdf.ede71849.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/file-pdf.svg
// module id = 534
// module chunks = 0